import { useState, useEffect, useRef } from 'react';

const CURRENT_VERSION = __APP_VERSION__;
const CHECK_COOLDOWN_MS = 5 * 60 * 1000; // 5 minutos entre checks

/**
 * Verifica se há uma nova versão do app quando o tab fica visível.
 * Retorna { updateAvailable: boolean }
 */
export function useVersionCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const lastCheckRef = useRef(0);

  useEffect(() => {
    // Skip em desenvolvimento — version check só faz sentido em produção
    if (!CURRENT_VERSION || !import.meta.env.PROD) return;

    async function checkVersion() {
      const now = Date.now();
      if (now - lastCheckRef.current < CHECK_COOLDOWN_MS) return;
      lastCheckRef.current = now;

      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        if (data.version && data.version !== CURRENT_VERSION) {
          setUpdateAvailable(true);
        }
      } catch {
        // silently ignore — rede offline, etc.
      }
    }

    function handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        checkVersion();
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Check também ao montar (caso o app já esteja stale no primeiro load)
    checkVersion();

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return { updateAvailable };
}
